module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "settings"
    }
  }, [_c('h1', [_vm._v("Settings")]), _vm._v(" "), _c('div', [_vm._v("\n    Time Limit:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.limit),
      expression: "limit"
    }],
    attrs: {
      "type": "number",
      "name": "name"
    },
    domProps: {
      "value": (_vm.limit)
    },
    on: {
      "change": _vm.changeLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.limit = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Select a font to play:")]), _vm._v(" "), _c('ul', _vm._l((_vm.fonts), function(font) {
    return _c('li', {
      class: {
        selected: _vm.selectedFont === font
      },
      on: {
        "click": function($event) {
          _vm.changeFont(font)
        }
      }
    }, [_c('span', {
      staticClass: "middle",
      style: ({
        fontFamily: font
      })
    }, [_vm._v(_vm._s(font))])])
  }))]), _vm._v(" "), _c('div', [_c('span', [_vm._v("Game Mode:")]), _vm._v(" "), _c('ul', _vm._l((_vm.modes), function(mode, index) {
    return _c('li', {
      staticClass: "ripple",
      class: {
        selected: _vm.selectedMode === index
      },
      on: {
        "click": function($event) {
          _vm.changeMode(index)
        }
      }
    }, [_c('span', {
      staticClass: "middle"
    }, [_vm._v(_vm._s(mode))])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f41cca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 34
// module chunks = 0